$(function () {
  const $drawerTrigger = $("[data-search-drawer]");
  const $searchDrawer = $(".search-drawer");
  const $searchInput = $("#search-drawer-query-input");
  const resultsContainer = $(".search-drawer-results-container");
  const $menuWrapper = $('.search-drawer-menu-wrapper'); // Menu wrapper selector

  $drawerTrigger.on("click keydown", function (e) {
    if (e.type === "click" || e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $searchDrawer.toggleClass("open");
      setTimeout(() => {
        if ($searchDrawer.hasClass("open")) {
          $searchInput.focus();
        } else {
          $('.btn.search-form').focus();
        }
      }, 300);
    }
  });

  $searchInput.on("input", async function () {
    const res = await fetch(
      "/search/suggest?section_id=search-drawer-results&q=" +
      encodeURIComponent(this.value) +
      "&resources[type]=product,collection&resources[limit_scope]=each"
    );
    const text = await res.text();
    const html = new DOMParser()
      .parseFromString(text, "text/html")
      .querySelector("#shopify-section-search-drawer-results").innerHTML;
    resultsContainer.html(html);

    // Check if the results container has any children and hide/show menu wrapper accordingly
    if (resultsContainer.children().length > 0) {
      $menuWrapper.hide(); // Hide the menu wrapper
    } else {
      $menuWrapper.show(); // Show the menu wrapper if no results
    }
  });

  $(".search-overlay").click(function () {
    $searchDrawer.removeClass("open");
  });

  $(document).on('keydown', function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      $searchDrawer.removeClass("open");
    }
  });
});
